import { Injectable } from '@angular/core';
import { IPaetepCfGenericMapperService } from '../../interfaces/paetep-cf-generic-mapper.service';
import { TimePickerAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/time-picker-answer-config.model';
import { EdlCfTimePickerModel } from '@edl-development/edl-custom-forms/lib/models/item-models/edl-cf-time-picker.model';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { EdlCfGenericModel, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { CustomFormQuestionType } from 'src/app/model/enum/observations/custom-forms/custom-form-question-type.enum';
import { CustomFormsHelpersService } from '../../custom-forms-helpers/custom-forms-helpers.service';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfTimeMapperService implements IPaetepCfGenericMapperService<TimePickerAnswerConfig, EdlCfTimePickerModel, string, Date | null> {
    constructor(private customFormsHelpersService: CustomFormsHelpersService) { }
    
    public toEdlModel = (child: CustomFormQuestionDisplayDTO<TimePickerAnswerConfig>): EdlCfTimePickerModel => {
        return {
            title: child.label,
            isRequired: child.required
        }
    }

    public toPaetepModel = ({
        formID, 
        sectionID,
        displayOrder,
        groupOrder,
        question
    } : {
        formID: string, 
        sectionID: string, 
        displayOrder: number,
        groupOrder: number,
        question: EdlCfGenericModel<EdlCfTimePickerModel>
    }): CustomFormQuestionDisplayDTO<TimePickerAnswerConfig> =>  {
        return this.customFormsHelpersService.createCustomFormQuestion<TimePickerAnswerConfig>({
            $type: CustomFormQuestionType.TIME,
            typeID: CustomFormQuestionType.TIME,
            formID,
            sectionID,
            questionID: question.id,
            readOnly: false,
            required: question.config.isRequired,
            displayOrder,
            groupOrder,
            label: (question.config.title ?? '').substring(0, MAX_TITLE_LENGTH),
            displayLabel: true,
            answerConfig: {
                prefill: ''
            }
        });
    }

    public toEdlAnswer = (answer: string = '', question: CustomFormQuestionDisplayDTO<TimePickerAnswerConfig>) =>
    {
        const timeSplit = answer.split(':');
        const hoursStr = timeSplit[0]?.trim() ?? '';
        const minutesAMPSplit = timeSplit[1]?.trim()?.split(' ') ?? '';
        const minutesStr = minutesAMPSplit[0]?.trim() ?? '';
        const AMPM = minutesAMPSplit[1]?.trim() ?? '';

        if (!hoursStr || !minutesStr) {
            return null;
        }

        const hours = Number(hoursStr);
        const minutes = Number(minutesStr);
        const hourAdjust = AMPM == 'PM' ? 12 : 0;

        if (isNaN(hours) || isNaN(minutes)) {
            return null;
        }

        const value = new Date();
        value.setHours(hours + hourAdjust);
        value.setMinutes(minutes);

        return value;
    }

    public toPaetepAnswer = (answer: Date | null | undefined, question: CustomFormQuestionDisplayDTO<TimePickerAnswerConfig>) => {
        const hours = answer?.getHours();
        const minutes = answer?.getMinutes();

        if (minutes == undefined || hours == undefined) {
            return null;
        }

        const AMPM = hours >= 12 ? 'PM' : 'AM';
        const hoursStr = (hours % 12).toString().padStart(2, '0');
        const minutesStr = minutes.toString().padStart(2, '0');

        return `${hoursStr}:${minutesStr} ${AMPM}`;
    }

}
